import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bombas',
  templateUrl: './bombas.component.html',
  styleUrls: ['./bombas.component.css']
})
export class BombasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
